import { render } from "./EWKSList.vue?vue&type=template&id=b6c22ef4&scoped=true"
import script from "./EWKSList.vue?vue&type=script&lang=js"
export * from "./EWKSList.vue?vue&type=script&lang=js"

import "./EWKSList.vue?vue&type=style&index=0&id=b6c22ef4&scoped=true&lang=css"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6c22ef4"]])

export default __exports__